export const messages = {
  en: {
    roomCreateFee: {
      customTemplate: 'Custom Template',
      customImport: 'Custom Import',
      batchCreate: 'Batch Create',
      batchCollectionLetter: 'Batch Collection Letter',
      roomNumPlaceholder: 'Room number, e.g. 1-1-1123',
      ownerNamePlaceholder: 'Please enter owner name',
      roomFee: 'Room Fee',
      paymentHistory: 'Payment History',
      rooms: 'Rooms',
      owner: 'Owner',
      callable: 'Callable',
      receiptReprint: 'Receipt Reprint',
      meterReadingRecords: 'Meter Reading Records',
      prepaidAccount: 'Prepaid Account',
      prepaidReprint: 'Prepaid Reprint',
      deposit: 'Deposit',
      feeDetail: 'Fee Detail',
      billingRules: 'Billing Rules',
      feeBills: 'Fee Bills'
    },
    inputSearchRoom: {
      noRoomFound: 'No room found'
    },
    inputSearchRoomDemo: {
      searchPlaceholder: 'Search by room number'
    },
    inputSearchRoomByOwnerDemo: {
      searchPlaceholder: 'Search by owner name'
    },
    tempImportRoomFee: {
      title: 'Temporary Fee',
      feeType: 'Fee Type',
      selectFeeType: 'Required, please select fee type',
      feeObj: 'Fee Object',
      inputFeeObj: 'Required, please fill in fee object',
      feeName: 'Fee Name',
      selectFeeItem: 'Required, please select fee item',
      feeItemDesc: 'Description: Items with formulas are dynamic fee items',
      inputFeeName: 'Required, please fill in fee name',
      select: 'Select',
      amount: 'Amount',
      inputAmount: 'Required, please fill in amount',
      startTime: 'Start Time',
      selectStartTime: 'Required, please select start time',
      endTime: 'End Time',
      selectEndTime: 'Required, please select end time',
      cancel: 'Cancel',
      submit: 'Submit',
      feeTypeRequired: 'Fee type cannot be empty',
      feeNameRequired: 'Fee name cannot be empty',
      feeObjRequired: 'Fee object cannot be empty',
      startTimeRequired: 'Start time cannot be empty',
      endTimeRequired: 'End time cannot be empty',
      endTimeMustAfterStart: 'End time must be after start time',
      amountRequired: 'Amount cannot be empty',
      createSuccess: 'Created successfully',
      createFailed: 'Creation failed'
    },
    tempImportRoomFeeDemo: {
      openModal: 'Open Temporary Fee Modal'
    },
    simplifyRoomFee: {
      selectFeeType: 'Select Fee Type',
      selectFeeItem: 'Select Fee Item',
      selectStatus: 'Select Status',
      currentRoom: 'Current Room',
      currentOwner: 'Current Owner',
      default: 'Default',
      monthly: 'Monthly',
      batchPayment: 'Batch Payment',
      tempFee: 'Temporary Fee',
      quantityPayment: 'Quantity Payment',
      waterElectricity: 'Water & Electricity',
      feePackage: 'Fee Package',
      createFee: 'Create Fee',
      arrearsPayment: 'Arrears Payment',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      receivableAmount: 'Receivable Amount',
      accountTime: 'Account Time',
      receivablePeriod: 'Receivable Period',
      description: 'Description',
      status: 'Status',
      operation: 'Operation',
      preDegrees: 'Previous Degrees:',
      curDegrees: 'Current Degrees:',
      unitPrice: 'Unit Price:',
      additionalFee: 'Additional Fee:',
      usage: 'Usage:',
      algorithm: 'Algorithm:',
      fixedFee: 'Fixed Fee:',
      moreOperations: 'More Operations',
      cancelFee: 'Cancel Fee',
      manualEnd: 'Manual End',
      feeChange: 'Fee Change',
      details: 'Details',
      chargeYearMonth: 'Charge Year-Month',
      note1: 'Note: The receivable end time "-" means not yet receivable or fee collection has ended',
      note2: 'Receivable amount -1 generally indicates an error in the fee item formula setting, please check',
      arrearsSubtotal: 'Arrears Subtotal:',
      valid: 'Valid',
      feeEnd: 'Fee End',
      payment: 'Payment',
      paymentHistory: 'Payment History'
    },
    simplifyHisFee: {
      feeItem: 'Fee Item',
      payerObject: 'Payer Object',
      receiptNumber: 'Receipt Number',
      manualGenerate: 'Manual Generate',
      cycle: 'Cycle(Month)',
      receivableReceived: 'Receivable/Received(Yuan)',
      accountDeduction: 'Account Deduction',
      paymentMethod: 'Payment Method',
      paymentPeriod: 'Payment Period',
      paymentTime: 'Payment Time',
      cashier: 'Cashier',
      status: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      detail: 'Detail',
      generateReceipt: 'Generate Receipt',
      systemGenerate: 'System Generate',
      custom: 'Custom',
      receiptNumberRequired: 'Required, please select receipt number generation method',
      cancel: 'Cancel',
      generate: 'Generate',
      viewInFee: 'view in fee'
    },
    simplifyOwnerRooms: {
      batchPay: 'Batch Payment',
      roomCode: 'Room Code',
      floor: 'Floor',
      type: 'Type',
      area: 'Built/Indoor Area',
      rent: 'Rent',
      validity: 'Validity',
      roomStatus: 'Room Status',
      roomOweFee: 'Room Owe Fee',
      updateDaily: 'Update Daily',
      actions: 'Actions',
      choose: 'Choose',
      currentRoom: 'Current Room',
      subtotalOweFee: 'Subtotal Owe Fee'
    },
    carDetailOwner: {
      ownerFace: 'Owner Face',
      name: 'Name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      idCard: 'ID Card',
      address: 'Address',
      roomCount: 'Room Count',
      memberCount: 'Member Count',
      carCount: 'Car Count',
      complaintCount: 'Complaint',
      repairCount: 'Repair',
      oweFee: 'Owe Fee',
      contractCount: 'Contract',
      actions: 'Actions',
      detail: 'Detail'
    },
    writeOweFeeCallable: {
      title: 'Callable Registration',
      room: 'Registration Room',
      roomPlaceholder: 'Required, please fill in the room',
      fees: 'Callable Fees',
      remark: 'Callable Remark',
      remarkPlaceholder: 'Please enter remark',
      cancel: 'Cancel',
      submit: 'Submit',
      success: 'Registration successful'
    },
    deleteOweFeeCallable: {
      title: 'Please confirm your operation!',
      confirmDelete: 'Confirm to delete owe fee callable',
      cancel: 'Cancel',
      confirm: 'Confirm Delete!',
      success: 'Delete successful'
    },
    simplifyCallable: {
      register: 'Register',
      callable: 'Callable',
      callableOrder: 'Callable Order',
      noRoomSelected: 'No room selected',
      id: 'ID',
      ownerName: 'Owner Name',
      payerObjName: 'Payer Object Name',
      feeName: 'Fee Name',
      amount: 'Amount',
      timePeriod: 'Time Period',
      callableWay: 'Callable Way',
      staffName: 'Staff Name',
      status: 'Status',
      remark: 'Remark',
      createTime: 'Create Time',
      actions: 'Operations',
      delete: 'Delete'
    },
    simplifyFeeReceipt: {
      selectFeeType: 'Please select fee type',
      selectCar: 'Please select car',
      selectContract: 'Please select contract',
      current: 'Current ',
      car: 'Car',
      room: 'Room',
      all: 'All ',
      receiptCode: 'Receipt Code',
      query: 'Query',
      print: 'Print',
      mergePrint: 'Merge Print',
      printSmall: 'Print Small',
      apply: 'Apply',
      feeType: 'Fee Type',
      owner: 'Owner',
      feeItem: 'Fee Item',
      timePeriod: 'Time Period',
      totalAmount: 'Total Amount',
      payTime: 'Pay Time',
      receiptId: 'Receipt ID',
      yuan: 'Yuan',
      fee: 'Fee',
      noCar: 'No car',
      noContract: 'No contract',
      selectReceipt: 'Please select receipt',
      contract: 'Contract'
    },
    simplifyMeterWaterLog: {
      selectMeterType: 'Select meter type',
      addMeterReading: 'Add meter reading',
      meterType: 'Meter Type',
      objectName: 'Object Name',
      previousReading: 'Previous Reading',
      currentReading: 'Current Reading',
      previousReadingTime: 'Previous Reading Time',
      currentReadingTime: 'Current Reading Time',
      createTime: 'Create Time'
    },
    prestoreAccount: {
      title: 'Prestore',
      accountType: 'Account Type',
      selectAccountType: 'Please select account type',
      ownerPhone: 'Owner Phone',
      ownerPhonePlaceholder: 'Required, please enter owner phone',
      ownerName: 'Owner Name',
      selectOwner: 'Required, please select owner',
      deductionRoom: 'Deduction Room',
      selectRoom: 'Required, please select room',
      prestoreAmount: 'Prestore Amount',
      prestoreAmountPlaceholder: 'Required, please enter prestore amount',
      paymentMethod: 'Payment Method',
      selectPaymentMethod: 'Required, please select payment method',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      cancel: 'Cancel',
      save: 'Save',
      validateOwner: 'Owner cannot be empty',
      validateAmount: 'Amount cannot be empty',
      validateAccountType: 'Please select account type',
      validateRemark: 'Remark cannot exceed 200 characters',
      saveSuccess: 'Prestore success',
      saveFailed: 'Prestore failed'
    },
    
    simplifyRefundDeposit: {
      chargeObject: 'Charge Object',
      feeItem: 'Fee Item',
      timePeriod: 'Time Period',
      amount: 'Amount',
      paymentTime: 'Payment Time',
      status: 'Status',
      operation: 'Operation',
      refundDeposit: 'Refund Deposit',
      detail: 'Detail'
    },
    deleteFeeRule: {
      confirmTitle: 'Please confirm your operation',
      confirmMessage: 'Confirm to delete the fee rule? When deleting the fee rule, related fees and payment records will also be deleted!',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete success',
      deleteFailed: 'Delete failed'
    },
    editFeeRule: {
      title: 'Bill Change',
      maxTime: 'Bill End Time',
      maxTimePlaceholder: 'Required, please fill in the bill end time',
      curYearMonth: 'Bill Day',
      curYearMonthPlaceholder: 'Required, please fill in the bill day',
      dateError: 'Bill day should be greater than {date}',
      maxTimeRequired: 'Bill end time is required',
      curYearMonthRequired: 'Bill day is required'
    },
    finishFeeRule: {
      title: 'Please confirm your operation',
      confirmMessage: 'End the fee bill, no new bill fees will be generated on the bill day!'
    },
    feeDetailFeeRule: {
      ruleId: 'Rule ID',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      createTime: 'Create Time',
      validPeriod: 'Valid Period',
      formula: 'Bill Formula',
      price: 'Price',
      additionalFee: 'Additional/Fixed Fee',
      status: 'Status',
      billDay: 'Bill Day',
      billCycle: 'Bill Cycle'
    },
    feeDetailRuleBill: {
      billName: 'Bill Name',
      feeItem: 'Fee Item',
      receivablePeriod: 'Receivable Period',
      receivableAmount: 'Receivable Amount',
      ruleId: 'Rule ID',
      feeId: 'Fee ID',
      status: 'Status',
      description: 'Description',
      price: 'Price',
      fixedFee: 'Fixed Fee'
    },
    deleteFee: {
      title: 'Please confirm your operation',
      confirmMessage: 'Confirm to delete the fee'
    },
    editFee: {
      title: 'Fee Change',
      startTime: 'Create Time',
      startTimePlaceholder: 'Required, please fill in the create time',
      endTime: 'Receivable Start Time',
      endTimePlaceholder: 'Required, please fill in the receivable start time',
      maxEndTime: 'Receivable End Time',
      maxEndTimePlaceholder: 'Required, please fill in the receivable end time',
      rateCycle: 'Rate Cycle',
      rateCyclePlaceholder: 'Required, please fill in the rate cycle (months)',
      rate: 'Rate',
      ratePlaceholder: 'Required, please fill in the rate',
      rateStartTime: 'Rate Start Time',
      rateStartTimePlaceholder: 'Required, please fill in the rate start time',
      startTimeError: 'Create time must be less than receivable start time',
      endTimeError: 'Receivable start time must be greater than create time',
      maxEndTimeError: 'Receivable end time must be greater than create time',
      rateStartTimeError: 'Rate start time must be greater than create time',
      startTimeRequired: 'Create time is required',
      endTimeRequired: 'Receivable start time is required'
    },
    roomCreateFeeAdd: {
      title: 'Create Fee',
      location: 'Room',
      locationPlaceholder: 'Required, please fill in the charge scope',
      feeType: 'Fee Type',
      feeTypePlaceholder: 'Required, please select fee type',
      feeItem: 'Fee Item',
      feeItemPlaceholder: 'Required, please select fee item',
      amount: 'Amount',
      amountPlaceholder: 'Required, please fill in the amount',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please fill in start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please fill in end time',
      rateCycle: 'Rate Cycle',
      rateCyclePlaceholder: 'Required, please fill in rate cycle (months)',
      rate: 'Rate',
      ratePlaceholder: 'Required, please fill in rate',
      rateStartTime: 'Rate Start Time',
      rateStartTimePlaceholder: 'Required, please fill in rate start time',
      validate: {
        locationRequired: 'Room is required',
        feeTypeRequired: 'Fee type is required',
        feeItemRequired: 'Fee item is required',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        startBeforeEnd: 'Start time must be before end time',
        endAfterStart: 'End time must be after start time'
      },
      successMessage: 'Fee created successfully'
    },
    roomCreateFeeAddDemo: {
      openModal: 'Open Create Fee Modal',
      successMessage: 'Fee created successfully'
    },
    addProxyFee: {
      title: 'Pay by Quantity',
      feeType: 'Fee Type',
      feeTypePlaceholder: 'Required, please select fee type',
      feeItem: 'Fee Item',
      feeItemPlaceholder: 'Required, please select fee item',
      feeItemTip: 'Note: Display items with formula (usage * unit price + additional fee)',
      chargeObject: 'Charge Object',
      chargeObjectPlaceholder: 'Required, please fill in room',
      consumption: 'Consumption',
      consumptionPlaceholder: 'Required, please fill in consumption',
      quantity: 'Quantity',
      amount: 'Amount',
      amountPlaceholder: 'Required, please fill in amount',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please fill in start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please fill in end time',
      waterFee: 'Water Fee',
      electricityFee: 'Electricity Fee',
      otherFee: 'Other',
      validate: {
        amountRequired: 'Amount is required',
        amountFormat: 'Invalid amount format, e.g. 3.00',
        consumptionRequired: 'Consumption is required',
        consumptionFormat: 'Invalid consumption format, e.g. 3.00',
        roomRequired: 'Room is required',
        feeRequired: 'Fee is required',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        startBeforeEnd: 'Start time must be before end time',
        endAfterStart: 'End time must be after start time',
        invalidConfig: 'Invalid fee item or formula error',
        amountTooSmall: 'Amount is too small'
      },
      successMessage: 'Saved successfully'
    },
    addProxyFeeDemo: {
      openModal: 'Open Pay by Quantity Modal',
      successMessage: 'Saved successfully'
    },
    exportFeeImportExcel: {
      title: 'Template Export',
      floor: 'Floor',
      feeItem: 'Fee Item',
      all: 'All',
      successMessage: 'Export successful'
    },
    exportFeeImportExcelDemo: {
      openModal: 'Open Template Export Modal'
    },
    doImportCreateFee: {
      title: 'Custom Create Fee',
      selectFile: 'Select File',
      clickUpload: 'Click to upload',
      fileTip: 'Required, please select data file',
      validate: {
        invalidFileType: 'Invalid Excel format',
        fileTooLarge: 'Excel file size cannot exceed 2MB'
      },
      successMessage: 'Import successful'
    },
    doImportCreateFeeDemo: {
      openModal: 'Open Custom Create Fee Modal'
    },
    downloadCollectionLetterOrder: {
      title: 'Batch Collection Letter',
      confirmExport: 'Confirm to export collection letter',
      selectFloor: 'Select Floor',
      floorPlaceholder: 'Required, please select floor'
    },
    downloadCollectionLetterOrderDemo: {
      openModal: 'Open Collection Letter Modal'
    }
  },
  zh: {
    roomCreateFee: {
      customTemplate: '自定义模板',
      customImport: '自定义导入',
      batchCreate: '批量创建',
      batchCollectionLetter: '批量催缴单',
      roomNumPlaceholder: '房屋编号,如1-1-1123',
      ownerNamePlaceholder: '请填写业主名称',
      roomFee: '房屋费用',
      paymentHistory: '缴费历史',
      rooms: '房屋',
      owner: '业主',
      callable: '催缴',
      receiptReprint: '补打收据',
      meterReadingRecords: '抄表记录',
      prepaidAccount: '预存账户',
      prepaidReprint: '预存补打',
      deposit: '押金',
      feeDetail: '费用详情',
      billingRules: '账单规则',
      feeBills: '费用账单'
    },
    inputSearchRoom: {
      noRoomFound: '未查询到房屋'
    },
    inputSearchRoomDemo: {
      searchPlaceholder: '按房号搜索'
    },
    inputSearchRoomByOwnerDemo: {
      searchPlaceholder: '按业主姓名搜索'
    },
    tempImportRoomFee: {
      title: '临时收费',
      feeType: '费用类型',
      selectFeeType: '必填，请选择费用类型',
      feeObj: '费用对象',
      inputFeeObj: '必填，请填写费用对象',
      feeName: '费用名称',
      selectFeeItem: '必填，请选择收费项目',
      feeItemDesc: '说明：显示公式为动态费用的费用项',
      inputFeeName: '必填，请填写费用名称',
      select: '选择',
      amount: '收费金额',
      inputAmount: '必填，请填写收费金额',
      startTime: '开始时间',
      selectStartTime: '必填，请填写开始时间',
      endTime: '结束时间',
      selectEndTime: '必填，请填写结束时间',
      cancel: '取消',
      submit: '提交',
      feeTypeRequired: '费用类型不能为空',
      feeNameRequired: '费用名称不能为空',
      feeObjRequired: '费用对象不能为空',
      startTimeRequired: '开始时间不能为空',
      endTimeRequired: '结束时间不能为空',
      endTimeMustAfterStart: '结束时间必须大于开始时间',
      amountRequired: '金额不能为空',
      createSuccess: '创建成功',
      createFailed: '创建失败'
    },
    tempImportRoomFeeDemo: {
      openModal: '打开临时收费模态框'
    },
    simplifyRoomFee: {
      selectFeeType: '请选择费用类型',
      selectFeeItem: '请选择收费项目',
      selectStatus: '请选择状态',
      currentRoom: '当前房屋',
      currentOwner: '当前业主',
      default: '默认',
      monthly: '按月',
      batchPayment: '批量缴费',
      tempFee: '临时收费',
      quantityPayment: '按量缴费',
      waterElectricity: '水电抄表',
      feePackage: '费用套餐',
      createFee: '创建费用',
      arrearsPayment: '欠费缴费',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      receivableAmount: '应收金额',
      accountTime: '建账时间',
      receivablePeriod: '应收时间段',
      description: '说明',
      status: '状态',
      operation: '操作',
      preDegrees: '上期度数：',
      curDegrees: '本期度数：',
      unitPrice: '单价：',
      additionalFee: '附加费：',
      usage: '用量：',
      algorithm: '算法：',
      fixedFee: '固定费：',
      moreOperations: '更多操作',
      cancelFee: '取消费用',
      manualEnd: '手工结束',
      feeChange: '费用变更',
      details: '详情',
      chargeYearMonth: '收费年月',
      note1: '注意：应收结束时间 "-" 表示未到应收时间或收费已结束',
      note2: '应收金额为-1一般为费用项公式设置出错请检查',
      arrearsSubtotal: '欠费小计：',
      valid: '有效',
      feeEnd: '收费结束',
      payment: '缴费',
      paymentHistory: '缴费历史'
    },
    simplifyHisFee: {
      feeItem: '费用项',
      payerObject: '收费对象',
      receiptNumber: '收据编号',
      manualGenerate: '手工生成',
      cycle: '周期(单位:月)',
      receivableReceived: '应收/实收(单位:元)',
      accountDeduction: '账户扣款',
      paymentMethod: '缴费方式',
      paymentPeriod: '缴费起始段',
      paymentTime: '缴费时间',
      cashier: '收银员',
      status: '状态',
      remark: '备注',
      operation: '操作',
      detail: '详情',
      generateReceipt: '生成收据',
      systemGenerate: '系统生成',
      custom: '自定义',
      receiptNumberRequired: '必填，请选择收据编号生成方式',
      cancel: '取消',
      generate: '生成',
      viewInFee: '费用中查看'
    },
    simplifyOwnerRooms: {
      batchPay: '批量缴费',
      roomCode: '房屋编号',
      floor: '楼层',
      type: '类型',
      area: '建筑/室内面积',
      rent: '租金',
      validity: '有效期',
      roomStatus: '房屋状态',
      roomOweFee: '房屋欠费',
      updateDaily: '按天更新',
      actions: '操作',
      choose: '选择',
      currentRoom: '当前房屋',
      subtotalOweFee: '欠费小计'
    },
    carDetailOwner: {
      ownerFace: '业主人脸',
      name: '姓名',
      gender: '性别',
      male: '男',
      female: '女',
      idCard: '身份证',
      address: '家庭住址',
      roomCount: '房屋数',
      memberCount: '业主成员',
      carCount: '车辆数',
      complaintCount: '投诉',
      repairCount: '报修',
      oweFee: '欠费',
      contractCount: '业主合同',
      actions: '操作',
      detail: '详情'
    },
    writeOweFeeCallable: {
      title: '催缴登记',
      room: '登记房屋',
      roomPlaceholder: '必填，请填写房屋',
      fees: '催缴费用',
      remark: '催缴说明',
      remarkPlaceholder: '请输入备注',
      cancel: '取消',
      submit: '提交',
      success: '登记成功'
    },
    deleteOweFeeCallable: {
      title: '请确认您的操作!',
      confirmDelete: '确定删除欠费催缴',
      cancel: '点错了',
      confirm: '确认删除!',
      success: '删除成功'
    },
    simplifyCallable: {
      register: '登记',
      callable: '催缴',
      callableOrder: '催缴单',
      noRoomSelected: '未选择房屋',
      id: '编号',
      ownerName: '业主名称',
      payerObjName: '付费对象名称',
      feeName: '费用名称',
      amount: '催缴金额',
      timePeriod: '欠费时间段',
      callableWay: '催缴方式',
      staffName: '催缴人',
      status: '状态',
      remark: '说明',
      createTime: '创建时间',
      actions: '操作',
      delete: '删除'
    },
    simplifyFeeReceipt: {
      selectFeeType: '请选择收费类型',
      selectCar: '请选择车辆',
      selectContract: '请选择合同',
      current: '当前',
      car: '车辆',
      room: '房屋',
      all: '全部',
      receiptCode: '收据编号',
      query: '查询',
      print: '打印',
      mergePrint: '合并打印',
      printSmall: '打印小票',
      apply: '申请单',
      feeType: '费用类型',
      owner: '业主',
      feeItem: '费用项目',
      timePeriod: '收费时间段',
      totalAmount: '总金额',
      payTime: '缴费时间',
      receiptId: '收据ID',
      yuan: '元',
      fee: '费',
      noCar: '没有车位',
      noContract: '没有合同',
      selectReceipt: '请选择收据',
      contract: '合同'
    },
    simplifyMeterWaterLog: {
      selectMeterType: '请选择表类型',
      addMeterReading: '水电抄表',
      meterType: '表类型',
      objectName: '对象名称',
      previousReading: '上期度数',
      currentReading: '本期度数',
      previousReadingTime: '上期读表时间',
      currentReadingTime: '本期读表时间',
      createTime: '创建时间'
    },
    prestoreAccount: {
      title: '预存',
      accountType: '账户类型',
      selectAccountType: '必填，请选择账户类型',
      ownerPhone: '业主手机',
      ownerPhonePlaceholder: '必填，请填写业主手机号',
      ownerName: '业主名称',
      selectOwner: '必填，请选择业主',
      deductionRoom: '扣款房屋',
      selectRoom: '必填，请选择房屋',
      prestoreAmount: '预存金额',
      prestoreAmountPlaceholder: '必填，请填写预存金额',
      paymentMethod: '支付方式',
      selectPaymentMethod: '必填，请选择支付方式',
      remark: '备注',
      remarkPlaceholder: '可填，请填写备注',
      cancel: '取消',
      save: '保存',
      validateOwner: '业主不能为空',
      validateAmount: '金额不能为空',
      validateAccountType: '请选择账户类型',
      validateRemark: '备注长度不能超过200位',
      saveSuccess: '预存成功',
      saveFailed: '预存失败'
    },
    
    simplifyRefundDeposit: {
      chargeObject: '收费对象',
      feeItem: '费用项',
      timePeriod: '时间段',
      amount: '金额',
      paymentTime: '缴费时间',
      status: '状态',
      operation: '操作',
      refundDeposit: '退押金',
      detail: '详情'
    },
    deleteFeeRule: {
      confirmTitle: '请确认您的操作',
      confirmMessage: '确定删除账单规则，删除账单规则时，相关费用及缴费记录也会被删除！',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    },
    editFeeRule: {
      title: '账单变更',
      maxTime: '账单结束时间',
      maxTimePlaceholder: '必填，请填写账单结束时间',
      curYearMonth: '账单日',
      curYearMonthPlaceholder: '必填，请填写账单日',
      dateError: '账单日应大于{date}',
      maxTimeRequired: '账单结束时间不能为空',
      curYearMonthRequired: '账单日不能为空'
    },
    finishFeeRule: {
      title: '请确认您的操作',
      confirmMessage: '结束费用账单，账单日不在产生新的账单费用！'
    },
    feeDetailFeeRule: {
      ruleId: '规则编号',
      feeItem: '费用项',
      feeFlag: '费用标识',
      createTime: '建账时间',
      validPeriod: '账单有效期',
      formula: '账单公式',
      price: '计费单价',
      additionalFee: '附加/固定费用',
      status: '状态',
      billDay: '账单日',
      billCycle: '账单周期'
    },
    feeDetailRuleBill: {
      billName: '账单名称',
      feeItem: '费用项',
      receivablePeriod: '应收时间段',
      receivableAmount: '应收金额',
      ruleId: '规则编号',
      feeId: '费用编号',
      status: '状态',
      description: '说明',
      price: '单价',
      fixedFee: '固定费'
    },
    deleteFee: {
      title: '请确认您的操作',
      confirmMessage: '确定删除费用'
    },
    editFee: {
      title: '费用变更',
      startTime: '建账时间',
      startTimePlaceholder: '必填，请填写建账时间',
      endTime: '应收开始时间',
      endTimePlaceholder: '必填，请填写应收开始时间',
      maxEndTime: '应收结束时间',
      maxEndTimePlaceholder: '必填，请填写应收结束时间',
      rateCycle: '递增周期',
      rateCyclePlaceholder: '必填，请填写递增周期,请填写月份',
      rate: '计费递增率',
      ratePlaceholder: '必填，请填写递增率',
      rateStartTime: '递增开始时间',
      rateStartTimePlaceholder: '必填，请填写递增开始时间',
      startTimeError: '建账时间必须小于计费起始时间',
      endTimeError: '计费起始时间必须大于建账时间',
      maxEndTimeError: '计费结束时间必须大于开始时间',
      rateStartTimeError: '递增开始时间必须大于开始时间',
      startTimeRequired: '建账时间不能为空',
      endTimeRequired: '计费起始时间不能为空'
    },
    roomCreateFeeAdd: {
      title: '创建费用',
      location: '房屋',
      locationPlaceholder: '必填，请填写收费范围',
      feeType: '费用类型',
      feeTypePlaceholder: '必填，请选择费用类型',
      feeItem: '收费项目',
      feeItemPlaceholder: '必填，请选择收费项目',
      amount: '收费金额',
      amountPlaceholder: '必填，请填写收费金额',
      startTime: '计费起始时间',
      startTimePlaceholder: '必填，请填写计费起始时间',
      endTime: '计费结束时间',
      endTimePlaceholder: '必填，请填写计费结束时间',
      rateCycle: '递增周期',
      rateCyclePlaceholder: '必填，请填写递增周期,请填写月份',
      rate: '计费递增率',
      ratePlaceholder: '必填，请填写递增率',
      rateStartTime: '递增开始时间',
      rateStartTimePlaceholder: '必填，请填写递增开始时间',
      validate: {
        locationRequired: '收费对象不能为空',
        feeTypeRequired: '费用类型不能为空',
        feeItemRequired: '费用项目不能为空',
        startTimeRequired: '计费起始时间不能为空',
        endTimeRequired: '计费终止时间不能为空',
        startBeforeEnd: '计费起始时间必须小于计费终止时间',
        endAfterStart: '计费终止时间必须大于计费起始时间'
      },
      successMessage: '创建收费成功'
    },
    roomCreateFeeAddDemo: {
      openModal: '打开创建费用弹窗',
      successMessage: '费用创建成功'
    },
    addProxyFee: {
      title: '按量缴费',
      feeType: '费用类型',
      feeTypePlaceholder: '必填，请选择费用类型',
      feeItem: '收费项目',
      feeItemPlaceholder: '必填，请选择收费项目',
      feeItemTip: '说明：显示公式为(用量*单价+附加费)的费用项',
      chargeObject: '收费对象',
      chargeObjectPlaceholder: '必填，请填写房屋',
      consumption: '用量',
      consumptionPlaceholder: '必填，请填写用量',
      quantity: '个数',
      amount: '金额',
      amountPlaceholder: '必填，请填写金额',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请填写开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请填写结束时间',
      waterFee: '水费',
      electricityFee: '电费',
      otherFee: '其他',
      validate: {
        amountRequired: '金额不能为空',
        amountFormat: '金额格式错误，如3.00',
        consumptionRequired: '用量不能为空',
        consumptionFormat: '用量格式错误，如3.00',
        roomRequired: '房屋必填',
        feeRequired: '费用必填',
        startTimeRequired: '开始时间不能为空',
        endTimeRequired: '结束时间不能为空',
        startBeforeEnd: '开始时间必须小于结束时间',
        endAfterStart: '结束时间必须大于开始时间',
        invalidConfig: '未选择收费项目或者收费项目公式错误',
        amountTooSmall: '输入金额太小'
      },
      successMessage: '保存成功'
    },
    addProxyFeeDemo: {
      openModal: '打开按量缴费弹窗',
      successMessage: '保存成功'
    },
    exportFeeImportExcel: {
      title: '模板导出',
      floor: '楼栋',
      feeItem: '费用项',
      all: '全部',
      successMessage: '导出成功'
    },
    exportFeeImportExcelDemo: {
      openModal: '打开模板导出弹窗'
    },
    doImportCreateFee: {
      title: '自定义创建费用',
      selectFile: '选择文件',
      clickUpload: '点击上传',
      fileTip: '必填，请选择数据文件',
      validate: {
        invalidFileType: '不是有效的Excel格式',
        fileTooLarge: 'Excel文件大小不能超过2M'
      },
      successMessage: '导入成功'
    },
    doImportCreateFeeDemo: {
      openModal: '打开自定义创建费用弹窗'
    },
    downloadCollectionLetterOrder: {
      title: '批量催缴单',
      confirmExport: '确认导出催缴单',
      selectFloor: '选择楼栋',
      floorPlaceholder: '必填，请选择楼栋'
    },
    downloadCollectionLetterOrderDemo: {
      openModal: '打开催缴单弹窗'
    }
  }
}